var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0637c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002caa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ba758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c8945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec54a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.04761905 9.9047619-.53874803.1577957.15779565-.53874808-.15779565-.53874803.53874803.15779565.53874802-.15779565-.15779564.53874803.15779564.53874808z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.04761905 4.19047619-.53874803.15779564.15779565-.53874802-.15779565-.53874802.53874803.15779564.53874802-.15779564-.15779564.53874802.15779564.53874802z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.57142857 6.47619048-.53874802.15779564.15779564-.53874802-.15779564-.53874803.53874802.15779564.53874802-.15779564-.15779564.53874803.15779564.53874802z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.52380952 7.23809524-.53874802.15779564.15779564-.53874802-.15779564-.53874803.53874802.15779565.53874803-.15779565-.15779565.53874803.15779565.53874802z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.19047619 8.19047619-.26937401.07889783.07889782-.26937402-.07889782-.26937402.26937401.07889783.26937401-.07889783-.07889782.26937402.07889782.26937402z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.4285714 6.7968662-4.8549044s1.51040816.78128927 2.08762043.36899483c.57721219-.41229445.2641488-2.04883001.2641488-2.04883001l6.85136457-4.89383182h-16z",
    fill: "url(#d)",
    mask: "url(#f)",
    transform: "matrix(-1 0 0 1 16 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.0177641 5.71428571s1.8395647-.30422246 2.0589954-1.16313244c.2194307-.85890996-1.7508287-1.47372938-1.8288056-1.78255208-.077977-.3088227.7241368-.08971164 1.078497 0 .3435255.08696866 1.01516.53004092 1.01516.53004092s-.0081225-.60991041-.0997024-.89155505c-.1538938-.47328468-.6367188-1.3732329-.6367188-1.3732329s.8189887.52527504 1.1703869.94456846c.2013475.24025066.2766701 1.3243991.5255767 1.69596354.4451283.66448163 1.483758-.07734862 1.0425037.62704613-.4412543.70439476-1.455657.80012968-2.2668975 1.10863096-.7356655.27976136-2.3738205.65615699-2.3738205.65615699z",
    fill: "url(#e)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 7.61904762c-1.05197095 0-1.9047619-.85279096-1.9047619-1.90476191 0-1.05197094.85279095-1.9047619 1.9047619-1.9047619 1.05197097 0 1.9047619.85279096 1.9047619 1.9047619 0 1.05197095-.85279093 1.90476191-1.9047619 1.90476191zm-.94610305-1.90476191-.19675409.38095239s.63937258-.14412612.85556175 0c.29277928.19518617.28729539.76190476.28729539.76190476h.38095238s-.12459063-.5558782.07101006-.94707961c.19560068-.39120143.6908947-.57672992.6908947-.57672992v-.76190476s-.51904396.55396703-1.14285714.76190476c-.6238132.20793773-1.14285714 0-1.14285714 0z",
    fill: "url(#e)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/CX.45efaae6e9fd7fba900e9402bb446d2f.svg";
export { ForwardRef as ReactComponent };